import { render, staticRenderFns } from "./LabelPrinter.vue?vue&type=template&id=4b53170c&scoped=true&"
import script from "./LabelPrinter.vue?vue&type=script&lang=js&"
export * from "./LabelPrinter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b53170c",
  null
  
)

export default component.exports